var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCareerTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.51819 3.53417L7.00012 0L4.48205 3.53417L0.342726 4.83688L2.9258 8.32383L2.88563 12.6631L7.00012 11.284L11.1146 12.6631L11.0744 8.32383L13.6575 4.83688L9.51819 3.53417ZM8.20032 5.25C8.20032 5.94036 7.64067 6.5 6.95032 6.5C6.25996 6.5 5.70032 5.94036 5.70032 5.25C5.70032 4.55964 6.25996 4 6.95032 4C7.64067 4 8.20032 4.55964 8.20032 5.25ZM4.00012 8.54353C4.00012 8.26837 4.14449 8.01338 4.38044 7.87181C5.99291 6.90433 8.00734 6.90433 9.6198 7.87181C9.85575 8.01338 10.0001 8.26837 10.0001 8.54353V9.3H4.00012V8.54353Z",
    fill: "#FFB46A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerTrack);
export default __webpack_public_path__ + "static/media/career-track.816f40ed4fe6aa1e027f094478bbaf58.svg";
export { ForwardRef as ReactComponent };